<template>
  <transition name="slide-fade">
    <div
      v-if="visible"
      class="fixed bottom-[calc(0.5rem+40px)] right-4 z-[1000] flex rounded-[4px] bg-producer-slate-toast px-8 py-4 text-white shadow-[0_3px_4px_0_rgba(0,0,0,0.14),0_3px_3px_-2px_rgba(0,0,0,0.12),0_1px_8px_0_rgba(0,0,0,0.2)]"
      style="border-left: 0.25rem solid #26C5DA"
    >
      <div class="mr-4">
        <i class="fas fa-exclamation-circle mt-2 text-2xl"></i>
      </div>

      <div>
        <p class="mb-1 text-[1.1em] font-bold">
          A new version of Producer is available
        </p>

        <p>
          Please reload to get the latest changes
        </p>

        <button
          class="mt-3 cursor-pointer whitespace-nowrap rounded border-0 bg-producer-button-primary px-4 py-2 text-sm font-semibold text-white transition hover:bg-producer-button-primaryHover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
          data-entity="producer-versionReload"
          data-test="version-check-toast"
          @click="onClickReload"
        >
          Reload
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
/**
* Component will continuously hit /ping on the producer API and check if the hash changes.
* If the hash has changed since it's last check, a toast notification
* will show prompting the user to reload the page.
*/

// File to check for changes, should point to something like a txt file containing a hash.
// Checking the root HTML file works too, but is less optimal.
const FilePath = '/version';

const PollInterval = 30e3;

export default {
  data() {
    return {
      visible: false,
      hash: null,
    };
  },

  mounted() {
    this.checkHash();
  },

  beforeUnmount() {
    clearTimeout(this.timeout);
  },

  methods: {
    onClickReload() {
      window.location.reload();
    },

    async checkHash() {
      try {
        const resp = await fetch(FilePath);
        const data = await resp.text();

        if (!this.hash) {
          // First request, so just store hash
          this.hash = data;
        } else if (this.hash !== data) {
          // Show the toast and don't bother polling for changes anymore.
          this.hash = data;
          this.visible = true;
          return;
        }
      } catch (err) { /* noop */ }

      this.timeout = setTimeout(() => this.checkHash(), PollInterval);
    },
  },
};
</script>
